import { CustomStyles } from '@components/ui/Theme/types'
import cle_overrides from '../__data/cle/theme-override.json'
import vde_overrides from '../__data/vde/theme-override.json'

const THEME_OVERRIDE = {
  cle: cle_overrides,
  vde: vde_overrides,
}

export const getThemeOverride = (): CustomStyles | undefined => {
  const brand = window.directBilling?.env?.brand
  if (brand) {
    return THEME_OVERRIDE[brand]
  }
}